export default class BookingFinanceDocument {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.createdAt = apiResponse.createdAt ? new Date(apiResponse.createdAt) : null;
        this.updatedAt = apiResponse.updatedAt ? new Date(apiResponse.updatedAt) : null;
        this.fileUrl = apiResponse.fileUrl;
        this.downloadFileUrl = apiResponse.downloadFileUrl;
        this.pdfStatus = apiResponse.pdfStatus;
        this.hasOldData = apiResponse.hasOldData ?? false;
    }

    clone() {
        const document = new BookingFinanceDocument({});
        document.id = this.id;
        document.createdAt = this.createdAt ? new Date(this.createdAt) : null;
        document.updatedAt = this.updatedAt ? new Date(this.updatedAt) : null;
        document.fileUrl = this.fileUrl;
        document.downloadFileUrl = this.downloadFileUrl;
        document.pdfStatus = this.pdfStatus;
        document.hasOldData = this.hasOldData;
        return document;
    }
}